import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormControlLabel, Switch } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";

const AreaCost = (props) => {
    const area = useRef();
    const value = useRef();
    const [available, setAvailable] = useState(true);

    useEffect(() => {
        if (props.area?.delivery_cost) {
            setAvailable(props.area?.delivery_cost.available);
        }
    }, [props.area?.delivery_cost]);

    const onChangeInputs = (e) => {
        props.getAreaCost({
            id: props.index,
            area: +area.current.value,
            cost: +value.current.value,
            available: available,
        });
    };

    const onChangeAvailable = (availableValue) => {
        props.getAreaCost({
            id: props.index,
            area: +area.current.value,
            cost: +value.current.value,
            available: availableValue,
        });
    };

    return (
        <div className="area-cost">
            <Form.Group className="mb-3" controlId="type">
                <Form.Label>
                    المنطقه<span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Select
                    ref={area}
                    defaultValue={props.area?.id || ""}
                    required
                    onChange={onChangeInputs}
                >
                    {/* A new row has no area yet. Without this option the list
                        showed its first area, and the form held another one. */}
                    {props.area?.id ? null : (
                        <option value="" disabled>
                            اختر المنطقة
                        </option>
                    )}
                    {props.areas?.map((area) => (
                        <option value={area.id} key={area.id}>
                            {area.name}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="free">
                <Form.Label>قيمه التوصيل (₪)</Form.Label>
                <Form.Control
                    onChange={onChangeInputs}
                    type="number"
                    placeholder="0"
                    min={0}
                    defaultValue={props.area?.delivery_cost.cost || ""}
                    ref={value}
                />
            </Form.Group>
            <Form.Group className="mb-3" controlId="optionAvailable">
                <FormControlLabel
                    control={
                        <Switch
                            color="warning"
                            checked={available}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setAvailable(true);
                                    onChangeAvailable(true);
                                }
                                if (!e.target.checked) {
                                    setAvailable(false);
                                    onChangeAvailable(false);
                                }
                            }}
                        />
                    }
                    label=""
                />
            </Form.Group>
            {props.deleteArea ? (
                <span
                    className="center"
                    style={{
                        color: "red",
                        backgroundColor: "transparent",
                        paddingTop: "10px",
                    }}
                    type="button"
                    onClick={() => {
                        props.deleteArea(props.index);
                    }}
                >
                    <FontAwesomeIcon icon={faTrashCan} size="lg" />
                </span>
            ) : null}
        </div>
    );
};

export default AreaCost;
